import React from 'react';
import OrganizationMetrics from './metrics/OrganizationMetrics';

const OrganizationHeaderMetrics = (props) => {
    const org = props.organization;
    const templateInfo = org && org.template && org.template.templateString;

    if (!org) {
        return null;
    }

    return (
        <div className="OrganizationHeaderMetrics">
            <div className="OrganizationHeaderMetrics__header">
                <h2>
                    <i className="fa fa-sitemap" /> {org.name}
                </h2>
                {templateInfo && (
                    <div className="OrganizationMetrics">
                        <div className="NextCheckinMetrics OrganizationHeaderMetrics__templateInfo">
                            <p className="header templateString">
                                {templateInfo}
                            </p>
                        </div>
                    </div>
                )}
            </div>

            <OrganizationMetrics organization={org} />
        </div>
    );
};

export default OrganizationHeaderMetrics;
